const config = {
   // Server URLs
   cdsUrl: process.env.REACT_APP_CDS_URL || "https://localhost:1288",
   primaryUrl: process.env.REACT_APP_PRIMARY_URL || "https://localhost:1299",

   // Get WebSocket URL from primary URL
   get primaryWsUrl() {
      return this.primaryUrl
         .replace("https://", "wss://")
         .replace("http://", "ws://");
   },

   // API base path
   apiBasePath: process.env.REACT_APP_API_BASE_URL || "/api",

   // Social Authentication
   socialAuth: {
      facebookAppId:
         process.env.REACT_APP_FACEBOOK_APP_ID || "2614305622105651",

      googleClientId:
         process.env.REACT_APP_GOOGLE_CLIENT_ID ||
         "302705543027-kudj54f8pq6oujl1ir8i8kc2lnp93u62.apps.googleusercontent.com",

      appleClientId: process.env.REACT_APP_APPLE_CLIENT_ID || "ai.pageshift.ai",
   },

   // Helper methods
   apiUrl(path) {
      // Ensure path starts with a slash
      if (!path.startsWith("/")) {
         path = "/" + path;
      }
      return `${this.apiBasePath}${path}`;
   },

   // Check if social auth is configured
   isSocialAuthConfigured() {
      return !!(
         this.socialAuth.facebookAppId ||
         this.socialAuth.googleClientId ||
         this.socialAuth.appleClientId
      );
   },

   // Get array of configured social providers
   getConfiguredSocialProviders() {
      const providers = [];
      if (this.socialAuth.facebookAppId) providers.push("facebook");
      if (this.socialAuth.googleClientId) providers.push("google");
      if (this.socialAuth.appleClientId) providers.push("apple");
      return providers;
   },
};

export default config;
